import styles from "../upsc-prestorming/prestorming.module.css";
import Link from "next/link";
import Image from "next/image";
import phone from "../../assets/images/upsc/phone.png";
const Prelims = () => {

  return (
    <>


  {/* <!-- Anna Nagar Timing Section --> */}
  <div className="container py-5">
        <div className="row">
          <div className="col-lg-6 col-12">
            <h2 className={`${styles.aboutheading1}`}>Anna Nagar Schedule</h2>
            <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:76677 66266" className={`${styles.numberbold}`}>76677 66266</a> <b>,</b> <a href="tel:044-66024500" className={`${styles.numberbold}`} >044-66024500</a></p>
            <p className={`${styles.acheiverrank1} mb-0`}>Door No 18, Old Plot No 109,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>New Plot No 259, AL Block, 4th Avenue,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>Shanthi Colony, Annanagar,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>Chennai 600040.</p>
            <p className={`${styles.redunderline} pt-3`}><Link href="https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0823643,80.2047976,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?entry=ttu" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-2024-Brochure.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch I (Sep 11th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-2-Anna-nagar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch II (Oct 15th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-3-Anna-Nagar.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch III (Nov 16th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-4-Anna-nagar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch IV (Dec 10th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-Batch-5-Anna-Nagar-Brochure_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch V (Jan 09th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming pamphlet 2024_Anna Nagar.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming  2023 - 2024 Batch VI (Feb  22nd) Schedule</Link></p>
          </div>

          <div className="col-lg-6 col-12">
            <h2 className={`${styles.aboutheading1}`}>Adyar Schedule</h2>
            <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:90252 78278" className={`${styles.numberbold}`} >90252 78278</a></p>
            <p className={`${styles.acheiverrank1} mb-0`}>No-2/23, 3rd Cross Street,</p>
            <p className={`${styles.acheiverrank1} mb-0`}>Padmanabhanagar, Adyar,</p>
            <p className={`${styles.acheiverrank1} mb-4`}>Chennai-600 020, Tamil Nadu.</p>
            <p className={`${styles.redunderline} pt-3`}><Link href="https://www.google.com/maps/place/Shankar+IAS+Academy+Adyar+%7C+UPSC+coaching+center+in+Adyar/@13.0498946,80.1958975,13z/data=!4m7!3m6!1s0x3a5267ec667c66d7:0x920d4111ec2c3ce6!8m2!3d13.0050985!4d80.2588174!15sChNzaGFua2FyIGlhcyBhY2FkZW15IgOIAQFaFSITc2hhbmthciBpYXMgYWNhZGVteZIBD2NvYWNoaW5nX2NlbnRlcuABAA!16s%2Fg%2F11cn5nj825?coh=164777&entry=tt&shorturl=1" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-2-adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch II (Oct 15th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-2-adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch III (Nov 16th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-batch-4-Adyar_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch IV (Dec 10th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming-Batch-5-Adyar-Brochure_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming 2023 - 2024 Batch V (Jan 09th) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} mb-0`}><Link href="/pdf/upsc-prelims-test-series-2023/Prestorming pamphlet 2024_Adyar.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}>Prestorming  2023 - 2024 Batch VI (Feb  22nd) Schedule</Link></p>
            <p className={`${styles.acheiverrank1} `}><span className={`${styles.dot} pe-2`}>* </span>Batch I is only for Annanagar</p>
          </div>
        </div>
      </div>


      {/* <!-- Fee Details and offer Section common --> */}
      <div className="container mb-3">
        <div className="row">
          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS + CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <span>
              <span>
                <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link>
              </span>
            </span>
          </div>
        </div>

        <div className="row pt-4">
          <div className="col">
            <p className={`${styles.aboutparagraph1} p-2`}>
              {" "}
              <span className={`${styles.dot} pe-2`}>*</span>Old student
              discount will be applicable only at spot payment.
            </p>
          </div>
        </div>
      </div>


    </>
  );
};

export default Prelims;